import { ref } from "vue";

const compare_datasets = ref({});

export {
    compare_datasets
}